<template>
  <div class="rule-detail">
    <z-fix-top keep-position
        class="fixtop"
        :zIndex="pageTitle ? 50 : 1"
        >
        <z-nav-bar
          class="navbar"
          :title="pageTitle"
          left-arrow
          @click-left="closePage">
        </z-nav-bar>
      </z-fix-top>
    <div class="normal" v-if="code != '2'">
      <img src="./images/normal.png" alt="" />
      <p>{{ msg }}</p>
    </div>
    <div class="rule-detail-container" ref="scrollContainer" @scroll.passive="judgeScroll" v-if="code == '2'">
      <div class="header">
        <div>验货未通过</div>
        <div>如您仍有异议，可选择再次提交验证</div>
      </div>
      <div class="result">
        <div class="title">处理结果</div>
        <div class="detail">{{ info.reason || '由于您在线验货提交的个人信息与当前账号实人认证信息不匹配，疑似非同一人，此次验货未通过。' }}</div>
        <div class="time">{{ new Date(Number(info.updateTime)).format('YYYY-MM-DD') || '-'}}</div>
      </div>
      <div class="info">
        <div class="title">提交的验证信息</div>
        <div class="body">
          <!-- <div class="item">
            <div class="left">提交时间</div>
            <div class="right">{{ new Date(Number(info.submitTime)).format('YYYY-MM-DD') || '-'}}</div>
          </div> -->
          <div class="item">
            <div class="left">上传凭证</div>
            <div class="right">
              <ImageList :infoList="evidencepics"></ImageList>
            </div>
          </div>
          <div v-if="info.userReason.length" class="item">
            <div class="left">事件描述</div>
            <div class="right">{{info.userReason}}</div>
          </div>
        </div>
      </div>
      <div class="product">
        <div class="title">{{ info.source != '11' ? '需验货的商品' : '需验货的订单' }}</div>
        <div class="productinfo">
            <z-image
              fit="cover"
              :set-pic-size="500"
              :src="info.headImage">
            </z-image>
            <div>
               <span class="title">{{ info.title }}</span>
               <div class="price" v-if="info.source != '11'">
                <span><span>¥&nbsp;</span> {{ Number(info.price)/100 }}</span>
               </div>
               <div class="orderid" v-else>
                <span>订单编号：{{ info.orderId }}</span>
                <span></span>
               </div>
            </div>
          </div>
      </div>
    </div>
    <z-button-group v-if="code == '2'">
        <z-button v-show="info.source == '11'" size="small-detail" type="primary" @click="goToDetail">查看订单详情</z-button>
        <z-button v-show="info.source != '11'" size="small-detail" type="primary" @click="submitAgain">我已准备好凭证，再次验货</z-button>
    </z-button-group>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { NavBar, FixTop, Button, ButtonGroup, Image } from '@zz-common/zz-ui'
import { lego } from '@zz-common/lego'
import { getcloudcheckconfig } from '@api/resourceApi'
import { queryParams, getCookie, debounce } from '../../lib/utils'
import { toast } from '../../native'
import ImageList from './ImageList'

const query = queryParams()

export default {
  name: 'CloudResult',
  components: {
    'z-nav-bar': NavBar,
    'z-fix-top': FixTop,
    'z-button': Button,
    'z-button-group': ButtonGroup,
    'z-image': Image,
    ImageList
  },
  data() {
    return {
      native,
      infoId: query.infoId || this.$route.query.infoId || '',
      strategyid: query.strategyid || this.$route.query.strategyid,
      servicetype: query.servicetype || this.$route.query.servicetype,
      result: true,
      code: '2',
      msg: '',
      pageTitle: '',
      btnText: '确定',
      info: {
        pid: '', //验货pid
        infoId: '', //商品id
        reason: '', //处理结果
        submitTime: '', //提交时间
        updateTime: '', //处理时间
        evidence: '', //图片凭证
        userReason: '', //事件描述，
        headImage: '', //商品首图
        title: '', //商品标题
        price: '', //商品价格
        source: '', //来源，区分底部按钮
        orderId: '', //订单号
        orderStatus: '' //订单状态
      }
    }
  },
  computed: {
    evidencepics() {
      return this.info.evidence.length ? this.info.evidence.split('|') : []
    }
  },
  methods: {
    closePage() {
      native.close()
    },
    goToDetail() {
      native.skipToUrl({
        targetUrl: `https://m.zhuanzhuan.com/trade/order_detail_v3/index.html?needHideHead=3&hiddenProgress=1&orderId=${this.info.orderId}`,
        needClose: '1'
      })
    },
    submitAgain() {
      native.skipToUrl({
        targetUrl: `https://feentry.zhuanzhuan.com/spam_cloudInspection?clientid=CloudInspectionPushSubmit&infoId=${this.info.infoId}&pid=${this.info.pid}`,
        needClose: '1'
      })
    },
    getcloudcheckconfig() {
      lego.send({
        pagetype: 'ZZUP_CLOUDRESULT',
        actiontype: 'CLICK',
        backup: {
          infoId: this.infoId,
          uid: getCookie('uid')
        }
      })
      return getcloudcheckconfig({
        infoId: this.infoId
      })
        .then((respData) => {
          const { code = '', msg = '', data = {} } = respData
          this.code = code
          this.msg = msg || ''
          this.info = { ...this.info, ...data }
          lego.send({
            pagetype: 'ZZUP_CLOUDRESULT',
            actiontype: 'CLICK_SUCCESS',
            backup: {
              code,
              infoId: data.infoId,
              uid: getCookie('uid')
            }
          })
          return respData
        })
        .catch((err) => {
          lego.send({
            pagetype: 'ZZUP_CLOUDRESULT',
            actiontype: 'CLICK_FAIL',
            backup: {
              infoId: this.infoId,
              uid: getCookie('uid')
            }
          })
          if (!err.message) return
          toast({
            msg: err.message || '网络错误',
            style: '2'
          })
        })
    },
    judgeScroll() {
      debounce(function() {
        if (this.$refs.scrollContainer.scrollTop >= 20 && this.pageTitle == '') {
          this.pageTitle = '验货未通过'
        } else if (this.$refs.scrollContainer.scrollTop < 10) {
          this.pageTitle = ''
        }
      }, 100, false).call(this)
    }
  },
  mounted() {
    this.getcloudcheckconfig()
  }
}
</script>

<style lang="less" scoped>
  @import './Result.less';
</style>
